import React from "react";
import {
  LlmRunFilters,
  LlmRunFilterKeys,
  llmRunNumberFilterKeys,
  llmRunStringFilterKeys,
} from "common/flowmaster/types/llm_run";
import {Button} from "@material-ui/core";
import Field from "./filtering/filter_field";

interface SelectorsProps {
  values: LlmRunFilters;
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, number | string | null>>,
  ) => void;
}
export default function Selectors({values, updateValue}: SelectorsProps) {
  const filters = [...llmRunNumberFilterKeys, ...llmRunStringFilterKeys];

  const clearAllFilters = () => {
    const clearedFilters: Partial<Record<LlmRunFilterKeys, null>> = {};
    filters.forEach(key => {
      clearedFilters[key] = null;
    });
    updateValue(clearedFilters);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        maxWidth: "800px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          flex: 1,
        }}
      >
        {filters.map(paramName => (
          <Field
            key={paramName + values[paramName]}
            label={getFieldLabel(paramName)}
            value={values[paramName]}
            updator={(value: number | string) =>
              updateValue({[paramName]: value})
            }
          />
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "1em",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={clearAllFilters}
          style={{height: "40px"}}
        >
          Reset
        </Button>
      </div>
    </div>
  );
}

function getFieldLabel(paramName: string): string {
  if (paramName === "user") {
    return "User";
  }
  return `${paramName} Id`;
}
